import { render, staticRenderFns } from "./PresidiPrestazioniListComponent.vue?vue&type=template&id=c44b5ec4&scoped=true"
import script from "./PresidiPrestazioniListComponent.vue?vue&type=script&lang=js"
export * from "./PresidiPrestazioniListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44b5ec4",
  null
  
)

export default component.exports